import {put, call, cancel} from 'redux-saga/effects';
import Creators, {forgetPasswordFailed} from '../state/AppRedux';
import {dashboardService} from '../services/dashboardService';
import {validateFormErrorResponse} from '../helpers';
import {navigate} from 'gatsby';

// get all dashboard
export function* getAllDashboard(data) {
    // console.log(data,"its data");
    yield put(Creators.fetching());

    let result = null;
    try {
        result = yield call(dashboardService.getDashboard, data);
        if (result && result.data.response) {
            yield put(Creators.dashboardFetchedSuccessfully(result.data.response));
        }
    } catch (e) {
        if (e.status === 401 || e.status === 412) {
            yield put(Creators.logout());
            navigate('/login');
        }
        yield put(Creators.stopFetching());
    }
}
